import styled from '@emotion/styled';
import { token } from '@angeplus/prever-component-lib';
import { LinkWrapper } from '@angeplus/prever-component-lib/nextjs';

import { PLANS } from './plans';

export const PlansList = () => {
  return (
    <PlansContainer>
      {PLANS.map((plan, index) => (
        <PlanLink href={plan.uri} key={index}>
          <PlanIcon>
            <plan.icon color={token.colors.solidAngeplusForeground} />
          </PlanIcon>
          <PlanLabel>{plan.label}</PlanLabel>
        </PlanLink>
      ))}
    </PlansContainer>
  );
};

const PlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${token.spacing.spacingLarge};
  margin: ${token.spacing.spacingXLarge} 0;

  @media (min-width: 968px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const PlanLink = styled(LinkWrapper)`
  display: flex;
  width: 165px;
  flex-direction: column;
  align-items: center;
  gap: ${token.spacing.spacingSmall};
  text-decoration: none;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-4px);
  }
`;

const PlanIcon = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #9ec6f2;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid ${token.colors.solidAngeplusForeground};

  @media (min-width: 968px) {
    width: 85px;
    height: 85px;
  }

  svg {
    width: 32px;
    height: 32px;
    color: ${token.colors.solidAngeplusForeground} !important;

    @media (min-width: 968px) {
      width: 40px;
      height: 40px;
    }
  }
`;

const PlanLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: white;
  text-align: center;
  font-family: ${token.typography.fontFamily01};

  @media (min-width: 968px) {
    font-size: 16px;
  }
`;
